"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceDialog = void 0;
var React = require("react");
var dialog_1 = require("../dialog");
var utils_1 = require("./utils");
var generic_1 = require("../generic");
var multiSelect_1 = require("../lib/multiSelect");
var buttons_1 = require("../buttons");
var mobx_react_1 = require("mobx-react");
var combobox_1 = require("../lib/combobox");
var mobx_1 = require("mobx");
var typestyle_1 = require("typestyle");
var ReferenceToLinkForm = function (props) {
    return React.createElement(mobx_react_1.Observer, null, function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ReferenceDialog__Form" },
                React.createElement("label", { htmlFor: "reference_dialog_link" }, gettext("URL")),
                React.createElement("input", { id: "reference_dialog_link", className: "form-control", type: 'text', value: props.reference.to_link, onChange: function (e) {
                        props.onUpdateDialogReference("to_link", e.currentTarget.value);
                    } }),
                React.createElement("label", { htmlFor: "reference_dialog_description" }, gettext("Description")),
                React.createElement("input", { className: "reference_description form-control", id: "reference_dialog_description", type: "text", value: props.reference.description, onChange: function (e) {
                        props.onUpdateDialogReference("description", e.currentTarget.value);
                    } })),
            React.createElement(generic_1.FloatRight, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: props.onSave }, gettext("Save reference"))));
    });
};
var ReferenceToFileForm = function (props) {
    return React.createElement(mobx_react_1.Observer, null, function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ReferenceDialog__Form" },
                React.createElement("div", { className: "custom-file" },
                    React.createElement("label", { className: "custom-file-label" },
                        gettext("Choose file"),
                        React.createElement("input", { type: "file", className: "custom-file-input", onChange: function (e) {
                                props.onUpdateDialogReference("to_file", e.currentTarget.files[0]);
                            } }))),
                React.createElement("label", { htmlFor: "reference_dialog_description" }, gettext("Description")),
                React.createElement("input", { className: "form-control", id: "reference_dialog_description", type: "text", value: props.reference.description, onChange: function (e) {
                        props.onUpdateDialogReference("description", e.currentTarget.value);
                    } })),
            React.createElement(generic_1.FloatRight, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: props.onSave }, gettext("Save reference"))));
    });
};
var ReferenceToObjectForm = function (props) {
    return React.createElement(mobx_react_1.Observer, null, function () {
        var type_ = utils_1.ReferenceChoices.getToType(props.reference);
        var toAttr = "";
        if (type_ == utils_1.ReferenceChoices.TO_RISK)
            toAttr = "to_risk";
        else if (type_ == utils_1.ReferenceChoices.TO_CONTROL)
            toAttr = "to_control";
        else if (type_ == utils_1.ReferenceChoices.TO_ACTION)
            toAttr = "to_action";
        var selectedSearchResult = (0, mobx_1.get)(props.reference, toAttr);
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ReferenceDialog__Form" },
                React.createElement("p", null, (0, utils_1.getReferenceDialogSubtitle)(props.reference)),
                React.createElement("p", null,
                    gettext("Currently this is a reference to:"),
                    React.createElement("strong", null, props.reference.repr),
                    "."),
                React.createElement("p", null,
                    gettext("If you just want to change the description you don't need to re-select the current object"),
                    "."),
                props.project_choices &&
                    React.createElement(React.Fragment, null,
                        React.createElement("label", { htmlFor: "reference_dialog_project_select" }, gettext("Project")),
                        React.createElement(generic_1.ChoiceSelect, { id: "reference_dialog_project_select", choices: props.project_choices, value: props.selected_project, onChange: function (e) {
                                props.onUpdateFilter("selected_project", e.currentTarget.value);
                            } })),
                React.createElement("label", { htmlFor: "reference_dialog_status_select" }, gettext("Status")),
                React.createElement(multiSelect_1.Multiselect, { id: "reference_dialog_status_select", classes: (0, typestyle_1.classes)("MultiSelect__Button", "gm--fullwidth"), choices: props.status_choices, value: props.selected_statuses || [], name: "status_selection", onChange: function (values) {
                        props.onUpdateFilter("selected_statuses", values);
                    } }),
                React.createElement("label", { htmlFor: "reference_dialog_search_box" }, gettext("Search")),
                React.createElement(combobox_1.AsyncComboBox, { id: "reference_dialog_search_box", fetchSuggestions: props.fetchSearchResults, value: selectedSearchResult ? selectedSearchResult.toString() : null, onChange: function (value) {
                        props.onUpdateDialogReference(toAttr, parseInt(value));
                    }, options: [] }),
                React.createElement("label", { htmlFor: "reference_dialog_description" }, gettext("Description")),
                React.createElement("input", { className: "reference_description form-control", id: "reference_dialog_description", type: "text", value: props.reference.description, onChange: function (e) {
                        props.onUpdateDialogReference("description", e.currentTarget.value);
                    } })),
            React.createElement(generic_1.FloatRight, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: props.onSave }, gettext("Save reference"))));
    });
};
var ReferenceDialog = (function (_super) {
    __extends(ReferenceDialog, _super);
    function ReferenceDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferenceDialog.prototype.render = function () {
        var props = this.props;
        var reference = props.reference;
        var form = null;
        if (reference) {
            var targetType = utils_1.ReferenceChoices.getToType(reference);
            switch (targetType) {
                case utils_1.ReferenceChoices.TO_LINK:
                    form = React.createElement(ReferenceToLinkForm, __assign({}, props.formProps));
                    break;
                case utils_1.ReferenceChoices.TO_FILE:
                    form = React.createElement(ReferenceToFileForm, __assign({}, props.formProps));
                    break;
                case utils_1.ReferenceChoices.TO_RISK:
                case utils_1.ReferenceChoices.TO_CONTROL:
                case utils_1.ReferenceChoices.TO_ACTION:
                    form = React.createElement(ReferenceToObjectForm, __assign({}, props.formProps));
                    break;
            }
        }
        return (React.createElement(dialog_1.Dialog, { isOpen: props.isOpen, isReady: props.isReady, contentLabel: gettext("Edit reference"), shouldCloseOnOverlayClick: true, onClose: props.onDialogClose, forcedWidth: "550px" }, reference &&
            React.createElement("div", { className: (0, typestyle_1.classes)("Dialog__ScrollWrapper", "ReferenceDialog") }, (reference.anonymised || reference.backwards) ?
                gettext("You are not allowed to edit this reference.")
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("p", null, (0, utils_1.getReferenceDialogTitle)(reference)),
                        form))));
    };
    ReferenceDialog = __decorate([
        mobx_react_1.observer
    ], ReferenceDialog);
    return ReferenceDialog;
}(React.Component));
exports.ReferenceDialog = ReferenceDialog;
